<template>
  <div class="footer-change-date">
    <span v-if="false">
      Verändert am {{ timestamp }}
    </span>
    <span v-if="false">
      15. März 2019 von Name
    </span>
  </div>
</template>

<script>
export default {
    name: 'FooterChangeDate',
    data () {
        return {
            timestamp: process.env.LAST_UPDATED,
        };
    },

};
</script>

<style scoped>
.footer-change-date {
  white-space: nowrap;
}
</style>
